module.exports = __webpack_public_path__ + "img/arrow-icon.730a01c1.svg";